export default __webpack_public_path__ + "static/media/manager.f2c04ffb.svg";